import { request } from './client';

// Visitor's country (resolved from IP) and suggested currency.
export const apiGetGeo = () => request('/geo');

// Live INR-base FX rates: { base: 'INR', rates: { USD: 0.012, ... }, fetchedAt }
export const apiGetRates = () => request('/geo/rates');

// Active display currencies: [{ code, name, symbol, locale, decimals }, ...]
export const apiGetCurrencies = () => request('/geo/currencies');

// Active supported countries: [{ code, name, currencyCode, flagEmoji, language }, ...]
export const apiGetCountries = () => request('/geo/countries');
